import mqtt from "mqtt/dist/mqtt.min.js"; // 引入mqtt依赖
import request from "@/assets/js/request.js";
import { i18n } from '@/i18n';
import CONFIG from '@/assets/js/config';
import { Message } from "element-ui";

var client; // mqtt客户端
let mqttConfig; // 业务配置对象
let publishTopic = null; // 订阅topic
let accelerationId = null; // 本次加速采集id（FetchEnergyFlowOnce 返回，扣除次数时使用）
let flowFetched = false; // 本次加速会话是否已结束（收到数据或超时中止后为 true，网络恢复不再自动重连）
let networkStatus = true; // 网络状态，默认为在线
let reconnectTimer = null; // 网络重连定时器
let messageCallback = null; // 外部消息回调
let fetchFailCallback = null; // 加速请求失败回调（通知外部清除超时定时器、恢复按钮）

//  默认配置
const MQTT_OPTIONS = {
  // connectTimeout: 5000, // 连接超时时间
  clientId: "clientId-energyflow-" + Math.random(), // clientId不能重复，这里可以随机生成
  username: "admin", // 用户名
  password: null, // 密码-调后端接口拿字段token
  clean: true, // 是否清除会话
  reconnectPeriod: 0, // 禁用自动重连（手动加速是一次性的，数据推送一次即断开，避免反复重连重复触发加速）
  keepalive: 30,
  reschedulePings: false,
};

/**
 * 设置消息回调函数
 * @param {function} fn - 外部传入的消息处理回调
 */
export function setMqttEnergyFlowCallback(fn) {
  messageCallback = fn;
}

/**
 * 设置加速请求失败回调（FetchEnergyFlowOnce 返回非0时触发，
 * 外部需清除超时定时器、恢复按钮，不再等待数据推送）
 */
export function setMqttEnergyFlowFailCallback(fn) {
  fetchFailCallback = fn;
}

/**
 * 获取本次加速采集id（扣除次数接口入参）
 */
export function getAccelerationId() {
  return accelerationId;
}

/**
 * 初始化 MQTT 连接（能流加速专用）
 * @param {object} config - 设备四要素 { pn, sn, devcode, devaddr }
 */
export function initMqttEnergyFlow(config) {
  // 若旧连接仍在，先断开，避免多连接并存
  if (client) {
    client.end(true);
    client = null;
  }

  // 构造mqtt配置对象
  mqttConfig = {
    ...config,
    // serviceCode: 2,
    serviceCode: 8,
  };

  // 重置本次加速采集id
  accelerationId = null;

  // 重置本次加速完成标记
  flowFetched = false;

  // 移除之前的网络状态监听
  delEnergyFlowNetworkListener();

  // 添加网络状态监听
  addNetworkListener();

  // 调取后端接口获取密码和topic主题
  request
    .postMicroserDess("/relay-ess/api/mqtt/getTopic", {
      pn: mqttConfig.pn,
      sn: mqttConfig.sn,
      devcode: mqttConfig.devcode,
      devaddr: mqttConfig.devaddr,
      serviceCode: mqttConfig.serviceCode,
    })
    .then((res) => {
      // 获取到主题和密码
      publishTopic = res.data.topic;
      MQTT_OPTIONS.password = res.data.token;
      console.log(MQTT_OPTIONS, "=====mqttEnergyFlow=====");
      console.log("mqttEnergyFlow初始化开始");

      // 兼容H5（web）
      // 根据环境选择协议：development 使用 ws，其他环境使用 wss
      const mqttProtocol = CONFIG.env === "development" ? "ws://" : "wss://";
      client = mqtt.connect(
        mqttProtocol + CONFIG.MQTT_IP,
        MQTT_OPTIONS,
        function (err) {
          console.log(err);
          console.log(publishTopic);
        },
      );

      // 连接mqtt服务器
      mqttConncat();
    });
}

// 连接mqtt服务器并监听
function mqttConncat() {
  // 移除已有监听器避免重复绑定
  client.removeAllListeners();
  // 绑定监听事件
  setupMqttEventListeners();
}

// 设置MQTT事件监听器
function setupMqttEventListeners() {
  client
    .on("connect", handleConnect)
    .on("reconnect", logReconnect)
    .on("error", logError)
    .on("end", logDisconnect)
    .on("close", logClose)
    .on("offline", logOffline)
    .on("disconnect", (packet) => {
      console.log("【disconnect】", packet);
    })
    .on("packetreceive", (packet) => {
      if (["connack", "disconnect"].includes(packet.cmd)) {
        console.log("【收到包】", packet.cmd, packet);
      }
    })
    .on("packetsend", (packet) => {
      if (["connect", "pingreq"].includes(packet.cmd)) {
        console.log("【发送包】", packet.cmd, packet);
      }
    });
}

// 处理连接成功事件
function handleConnect() {
  console.log("mqttEnergyFlow连接成功");
  if (!client) return;
  if (typeof publishTopic === "string" && publishTopic.trim()) {
    // 订阅主题
    client.subscribe(publishTopic, function (err) {
      if (!err) {
        console.log("mqttEnergyFlow已成功订阅主题:", publishTopic);

        if (typeof mqttListen === "function") {
          mqttListen(() => {
            // 在这里处理业务功能：直接手动触发一次加速采集
            fetchEnergyFlowOnce(mqttConfig);
          });
        }
      } else {
        console.error("mqttEnergyFlow订阅主题失败:", err);
      }
    });
  }
}

// 监听mqtt消息
function mqttListen(callback) {
  console.log("mqttEnergyFlow监听器启动");
  // 监听消息
  client.on("message", function (topic, message) {
    const res = JSON.parse(message.toString());
    console.log(res, "mqttEnergyFlow数据");
    if (res.code === 0) {
      // 解析消息数据，通过回调函数通知外部
      const redata = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
      if (typeof messageCallback === "function") {
        messageCallback(redata);
      }
      // 数据只推送一次，收到后断开连接（下次手动加速才重新启动mqtt）
      if (!flowFetched) {
        flowFetched = true;
        mqttEnergyFlowDisconnect();
      }
    } else {
      // 处理离线业务：提示并断开
      Message.warning(i18n.t('device.Device_Offline'));
      // Message.warning("设备离线");
      mqttEnergyFlowDisconnect();
    }
  });
  // 监听器绑定完成，调用回调
  if (typeof callback === "function") {
    callback();
  }
}

// 手动触发一次加速采集（获取到topic并且连接mqtt后调用）
function fetchEnergyFlowOnce(config) {
  if (!client || !client.connected) {
    console.log("MQTT 未连接，跳过加速采集");
    return;
  }
  request
    .postMicroserDess("/relay-ess/api/FetchEnergyFlowOnce", config)
    .then((res) => {
      console.log(res, "mqttEnergyFlow FetchEnergyFlowOnce");
      if (res.code === 0) {
        accelerationId = res.data.accelerationId;
      } else {
        // 加速请求失败：不再等待数据推送，通知外部（清除定时器、恢复按钮）后直接中止会话
        Message.warning(res.message || i18n.t("collectionFrequencyUP.collect_fast_fail"));
        if (typeof fetchFailCallback === "function") {
          fetchFailCallback();
        }
        abortMqttEnergyFlow();
      }
    })
    .catch((err) => {
      // 请求异常同样视为失败：通知外部后中止会话
      console.error("加速采集请求失败:", err);
      if (typeof fetchFailCallback === "function") {
        fetchFailCallback();
      }
      abortMqttEnergyFlow();
    });
}

// 断开连接
export function mqttEnergyFlowDisconnect() {
  console.log("mqttEnergyFlow触发了断开");
  if (client) {
    // 主动断开前移除所有事件监听：close/offline 等事件不再触发回调，
    // 彻底避免主动断开被误判为"意外断开"（不论事件同步还是异步触发）
    client.removeAllListeners();
    client.end(true);
    client = null;
  }
}

/**
 * 中止本次加速会话（超时判定失败/切换设备/销毁组件时调用）
 * 断开连接 + 清除待执行的网络重连定时器 + 移除网络监听，
 * 确保会话彻底结束，网络恢复也不会重新拉起连接
 */
export function abortMqttEnergyFlow() {
  mqttEnergyFlowDisconnect();
  // 清除待执行的网络重连定时器，避免断开后又被拉起
  if (reconnectTimer) {
    clearTimeout(reconnectTimer);
    reconnectTimer = null;
  }
  // 标记会话已结束，网络恢复时不再自动重连（下次 initMqttEnergyFlow 会重置）
  flowFetched = true;
  // 移除网络状态监听
  delEnergyFlowNetworkListener();
}

// 重连函数 已禁用重连 reconnectPeriod: 0, // 禁用自动重连
function logReconnect(error) {
  console.log("mqttEnergyFlow正在重连...", error);
}

// 连接失败：本次加速无法进行，立即判定失败（不再傻等超时）
function logError(error) {
  console.log("mqttEnergyFlow连接失败...", error);
  handleUnexpectedDisconnect();
}

// 连接断开
function logDisconnect() {
  console.log("mqttEnergyFlow连接断开");
  handleUnexpectedDisconnect();
}

// 连接关闭
function logClose() {
  console.log("mqttEnergyFlow连接关闭");
  handleUnexpectedDisconnect();
}

// 客户端下线
function logOffline() {
  console.log("mqttEnergyFlow客户端下线");
  handleUnexpectedDisconnect();
}

/**
 * 意外断开处理：
 * 主动断开（mqttEnergyFlowDisconnect/abort）会先把 client 置为 null，
 * 此时 client 仍存在说明是后端/网络导致的意外断开；
 * 若尚未收到数据（!flowFetched），本次加速注定等不到推送，
 * 立即判定失败：提示、通知外部（清定时器、恢复按钮）、中止会话，不再傻等超时
 */
function handleUnexpectedDisconnect() {
  if (!client || flowFetched) return;
  console.log("mqttEnergyFlow意外断开且未收到数据，判定本次加速失败--(后端主动断开)");
  Message.warning(i18n.t("collectionFrequencyUP.collect_fast_fail"));
  if (typeof fetchFailCallback === "function") {
    fetchFailCallback();
  }
  abortMqttEnergyFlow();
}

// 添加网络状态监听
function addNetworkListener() {
  // 监听网络状态变化
  window.addEventListener("online", handleNetworkOnline);
  window.addEventListener("offline", handleNetworkOffline);
}

// 删除网络状态监听
export function delEnergyFlowNetworkListener() {
  // 移除网络监听器避免重复绑定
  window.removeEventListener("online", handleNetworkOnline);
  window.removeEventListener("offline", handleNetworkOffline);
}

// 网络连接恢复处理
function handleNetworkOnline() {
  console.log("网络已连接");
  networkStatus = true;
  // 网络恢复后尝试重连MQTT（加速已完成则不再重连）
  if (!client && !flowFetched) {
    console.log("网络恢复，尝试重连mqttEnergyFlow");
    reconnectMqtt();
  }
}

// 网络断开处理
function handleNetworkOffline() {
  console.log("网络已断开");
  networkStatus = false;
  // 网络断开：本次加速必然等不到数据推送，立即判定失败（不再傻等超时）
  if (client && !flowFetched) {
    console.log("网络断开，判定本次加速失败");
    Message.warning(i18n.t("collectionFrequencyUP.collect_fast_fail"));
    if (typeof fetchFailCallback === "function") {
      fetchFailCallback();
    }
    abortMqttEnergyFlow();
  }
}

// 重连MQTT
function reconnectMqtt() {
  if (reconnectTimer) {
    clearTimeout(reconnectTimer);
  }

  // 如果已经有连接，先断开
  if (client) {
    client.end(true);
    client = null;
  }

  reconnectTimer = setTimeout(() => {
    if (networkStatus && mqttConfig && !flowFetched) {
      console.log("开始重连mqttEnergyFlow");
      initMqttEnergyFlow({
        pn: mqttConfig.pn,
        sn: mqttConfig.sn,
        devcode: mqttConfig.devcode,
        devaddr: mqttConfig.devaddr,
      });
    }
  }, 1000); // 延迟1秒重连，确保网络完全恢复
}
